<template>
  <div class="payment-method-form-container">
    <Panel title="6. วิธีชำระเบี้ยประกัน">
      <div class="payer-information-section">
        <div class="description-text">ข้อมูลส่วนบุคคลของผู้ชำระเบี้ยประกันภัย</div>
        <div class="payer-information-form row clearfix">
          <div class="form-group col-sm-12">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">
                ชื่อ - สกุล
              </span>
              <Dropdown
                class="form-control"
                :options="generateFamilyPayerListOptions"
                v-model="payerInformation.payerId"
                :selectedValue="payerInformation.payerId"
                :disabled="isDisabledForm || isCombinePayment"
                v-if="typeInsurance !== 'personal'"
              />
              <input
                type="text"
                class="form-control"
                :value="generatePayerFullname"
                disabled
                v-else
              />
            </div>
          </div>
          <div class="form-group col-sm-9" v-if="checkPayerRelationshipCondition">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">
                มีความสัมพันธ์เป็น
              </span>
              <Dropdown
                class="form-control"
                :class="{ 'bd-red': applicationValidationErrors.has('payerRelationship') }"
                :options="generateBeneficiaryRelationshipOptions"
                v-model="payerInformation.relationship"
                :selectedValue="payerInformation.relationship"
                :disabled="isDisabledForm"
              />
              <span class="input-group-addon nobd-nobg">
                กับผู้เอาประกันภัย
              </span>
            </div>
          </div>
          <div class="pay-all-checkbox-container col-sm-12" v-if="isFirstApplicationPerson">
            <Checkbox
              :isCheck="isCombinePayment"
              :onCheck="onCheckPayAllApplication"
              optionText="ฉันต้องการรวมทุกเบี้ยกรมธรรม์เป็นยอดชำระเดียว โดยใช้ข้อมูลของการจ่ายนี้"
              :disabled="isDisabledForm"
            />
          </div>
        </div>
      </div>
      <div class="payment-method-section">
        <div class="description-text">
          ช่องทางการชำระ
          <span
            class="payment-method-error-text"
            v-if="applicationValidationErrors.has('paymentMethod')"
          >
            * กรุณาเลือกช่องทางการชำระ
          </span>
        </div>
        <div class="payment-method-form">
          <div class="payment-method-radio-container" v-if="checkPaymentMethodCondition">
            <Radio
              name="paymentMethod"
              :label="3"
              v-model="paymentMethod"
              :disabled="isDisabledForm || (!isFirstApplicationPerson && isCombinePayment)"
            >
              <i class="far fa-credit-card" />
              บัตรเครดิต / เดบิต
            </Radio>
          </div>
          <div class="payment-method-radio-container" v-if="checkPaymentMethodCondition">
            <Radio
              name="paymentMethod"
              :label="4"
              v-model="paymentMethod"
              :disabled="isDisabledForm || (!isFirstApplicationPerson && isCombinePayment)"
            >
              <i class="fas fa-qrcode" />
              QR Code
            </Radio>
          </div>
          <div class="payment-method-radio-container">
            <Radio
              name="paymentMethod"
              :label="1"
              v-model="paymentMethod"
              :disabled="isDisabledForm || (!isFirstApplicationPerson && isCombinePayment)"
            >
              <i class="far fa-file-alt" />
              Bill payment
            </Radio>
          </div>
          <div class="payment-method-radio-container">
            <Radio
              name="paymentMethod"
              :label="2"
              v-model="paymentMethod"
              :disabled="isDisabledForm || (!isFirstApplicationPerson && isCombinePayment)"
            >
              บัญชีธนาคาร ttb
            </Radio>
            <div class="payment-method-tmb-container clearfix" v-show-slide="paymentMethod === 2">
              <div class="payment-method-tmb-form">
                <div class="form-group col-sm-5 col-xs-12">
                  <div class="input-group">
                    <span class="input-group-addon nobd-nobg">
                      เลขที่บัญชี
                    </span>
                    <input
                      type="tel"
                      class="form-control"
                      v-mask="'###-#-#####-#'"
                      v-model="methodTmbInformation.accountNumber"
                      @blur="onTmbAccountNumberInputBlur"
                      :disabled="isDisabledForm"
                    />
                  </div>
                  <div
                    class="error-text-section"
                    v-if="!_.isNull(isAccountNumberCorrected) && !isAccountNumberCorrected"
                  >
                    เลขที่บัญชีไม่ถูกต้อง กรุณากรอกเลขบัญชีใหม่
                  </div>
                </div>
                <div class="form-group col-sm-7 col-xs-12">
                  <div class="input-group">
                    <span class="input-group-addon nobd-nobg">
                      ชื่อบัญชี
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      v-model="methodTmbInformation.accountName"
                      disabled
                    />
                  </div>
                </div>
                <div class="form-group col-sm-6 col-xs-12">
                  <div class="input-group">
                    <span class="input-group-addon nobd-nobg">
                      Product code
                    </span>
                    <input
                      type="tel"
                      class="form-control"
                      v-model="methodTmbInformation.productCode"
                      disabled
                    />
                  </div>
                </div>
                <div class="form-group col-sm-6 col-xs-12">
                  <div class="input-group">
                    <span class="input-group-addon nobd-nobg">
                      เบอร์โทรศัพท์
                    </span>
                    <input
                      type="tel"
                      class="form-control"
                      v-model="payerInformation.phone"
                      disabled
                    />
                  </div>
                </div>
                <div
                  class="warning-validate-information-section col-sm-12"
                  v-if="isAccountNumberCorrected && isAccountPayable && !isVerificationCompleted"
                >
                  <i class="fas fa-exclamation-triangle warning-icon" />
                  กรุณาตรวจสอบข้อมูลผู้ชำระเบี้ยประกันภัยก่อนดำเนินการต่อ
                </div>
                <div
                  class="otp-information-text col-sm-12"
                  v-if="
                    isAccountNumberCorrected &&
                      isAccountPayable &&
                      !isVerificationCompleted &&
                      !isShowOtp
                  "
                >
                  เพื่อดำเนินการต่อจะมีรหัส OTP ส่งไปหาคุณ
                  {{ methodTmbInformation.accountName }} หมายเลขโทรศัพท์
                  {{ payerInformation.phone }}
                </div>
                <div class="submit-btn-container">
                  <Button
                    type="info"
                    @click.native="sendOtpVerification"
                    v-if="!isVerificationCompleted"
                    :disabled="
                      !isAccountNumberCorrected || !isAccountPayable || isDisabledForm || isShowOtp
                    "
                  >
                    ดำเนินการต่อ
                  </Button>
                </div>
              </div>
              <div
                class="otp-section"
                v-if="isAccountPayable && isShowOtp && !isVerificationCompleted"
              >
                <div class="otp-information-section">
                  <div class="phone-number-information">
                    กรุณาใส่รัหัส OTP ที่ส่งไปยังหมายเลขโทรศัพท์
                    {{ payerInformation.phone }}
                  </div>
                  <div class="reference-number-information">
                    รหัสอ้างอิง {{ otp.referenceCode }}
                  </div>
                </div>
                <div class="otp-form form-group">
                  <div class="otp-input input-group">
                    <input
                      type="tel"
                      class="form-control"
                      v-model="otp.otpCode"
                      :disabled="isDisabledForm"
                    />
                  </div>
                </div>
                <div class="otp-timeout-time" v-if="otp.referenceCode">
                  กรุณากรอกรหัส OTP ภายใน 3 นาที
                </div>
                <div class="resend-otp-section">
                  ยังไม่ได้รับ OTP?
                  <span class="resend-otp-btn" @click="sendOtpVerification">ส่งอีกครั้ง</span>
                </div>
                <div class="otp-submit-btn-container">
                  <Button
                    type="info"
                    @click.native="submitOtpVerification"
                    :disabled="isDisabledForm"
                  >
                    ยืนยัน
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import _ from 'lodash'

import Button from '@/components/Button'
import Checkbox from '@/components/Checkbox'
import Dropdown from '@/components/Dropdown'
import Panel from '@/components/Panel'
import Radio from '@/components/Radio'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

const { mapFields: mapFamilyFields } = createHelpers({
  getterType: 'getFamilyFields',
  mutationType: 'updateFamilyFields',
})

export default {
  name: 'PaymentMethodForm',
  props: ['typeInsurance', 'isFirstApplicationPerson'],
  watch: {
    'payerInformation.payerId'(newVal, oldVal) {
      const isFamily = _.get(this.applicationInformation, 'familyQuotation.familyId', null)

      if (!_.isEqual(newVal, oldVal) && oldVal && isFamily) {
        this.updatePayerInformation(newVal)
      }
    },
    isCombinePayment(val) {
      if (val !== null) {
        this.updateMainPayer(val)
      }
    },
  },
  computed: {
    ...mapApplicationFields({
      applicationInformation: 'data.applicationInformation',
      payerInformation: 'data.paymentMethod.payerInformation',
      paymentMethod: 'data.paymentMethod.method',
      isCombinePayment: 'data.paymentMethod.isCombinePayment',
      methodTmbInformation: 'data.paymentMethod.tmbMethodInformation',
      isAccountNumberCorrected: 'data.paymentMethod.tmbMethodInformation.isAccountNumberCorrected',
      isAccountPayable: 'data.paymentMethod.tmbMethodInformation.isAccountPayable',
      isShowOtp: 'data.paymentMethod.tmbMethodInformation.isShowOtp',
      isVerificationCompleted: 'data.paymentMethod.tmbMethodInformation.isVerificationCompleted',
      otp: 'data.paymentMethod.tmbMethodInformation.otp',
    }),
    ...mapFamilyFields({
      beneficiaryRelationship: 'beneficiaryRelationship.data',
      familyPayerList: 'familyPayer.data',
    }),
    ...mapGetters({
      isDisabledForm: 'isDisabledApplicationForm',
      applicationValidationErrors: 'applicationValidationErrors',
    }),
    generatePayerFullname() {
      const { namePrefix, firstname, lastname } = this.payerInformation

      return `${namePrefix || ''} ${firstname} ${lastname}`
    },
    generateFamilyPayerListOptions() {
      const defaultOption = {
        value: '',
        description: 'โปรดระบุผู้ชำระเบี้ยประกันภัย',
      }

      const familyPayerOptions = this.familyPayerList.map(data => ({
        value: data.payerId,
        description: `${data.title || ''} ${data.firstname} ${data.lastname}`,
        key: `${data.payerId}-${data.family_order}`,
      }))

      if (this.payerInformation.payerId) {
        return familyPayerOptions
      }

      return [defaultOption, ...familyPayerOptions]
    },
    generateBeneficiaryRelationshipOptions() {
      const defaultOption = {
        value: '',
        description: 'โปรดระบุความสัมพันธ์',
      }

      const beneficiaryRelationshipOptions = this.beneficiaryRelationship.map(data => ({
        value: data.id,
        description: data.description,
      }))

      if (this.payerInformation.relationship) {
        return beneficiaryRelationshipOptions
      }

      return [defaultOption, ...beneficiaryRelationshipOptions]
    },
    checkPayerRelationshipCondition() {
      const isPaidByInsuredPerson = _.get(
        this.applicationInformation,
        'quotation.isPaidByInsuredPerson',
        false,
      )
      const isCombinePayment = _.get(
        this.applicationInformation,
        'familyQuotation.isCombinePayment',
        false,
      )

      if (this.isFirstApplicationPerson) {
        return !isPaidByInsuredPerson
      }

      return isCombinePayment || !isPaidByInsuredPerson
    },
    checkPaymentMethodCondition() {
      if (this.typeInsurance === 'family') {
        return this.isCombinePayment
      }

      return true
    },
  },
  components: {
    Button,
    Checkbox,
    Dropdown,
    Panel,
    Radio,
  },
  methods: {
    ...mapActions([
      'updatePayerInformation',
      'updateMainPayer',
      'getTmbAccountInformation',
      'sendOtpVerification',
      'verifyOtpVerification',
    ]),
    onTmbAccountNumberInputBlur() {
      const accountNumberWithoutDashed = this.methodTmbInformation.accountNumber.replace(/-/gi, '')
      const accountLength = _.size(accountNumberWithoutDashed)
      const accountPrefix = '0000'

      if (this.paymentMethod === 2 && accountLength === 10) {
        this.getTmbAccountInformation(`${accountPrefix}${accountNumberWithoutDashed}`)
      }
    },
    submitOtpVerification() {
      if (this.otp.otpCode) {
        this.verifyOtpVerification()
      }
    },
    onCheckPayAllApplication($evt) {
      this.isCombinePayment = $evt.target.checked
    },
  },
}
</script>

<style lang="scss">
.payment-method-form-container {
  .payer-information-section {
    border-bottom: 1px dashed #ccc;
    margin-bottom: 24px;
    padding-bottom: 24px;

    .description-text {
      margin-bottom: 16px;
    }

    .pay-all-checkbox-container {
      .option-title {
        font-size: 14px;
        line-height: 18px;
      }
    }
  }

  .payment-method-section {
    .description-text {
      margin-bottom: 16px;

      .payment-method-error-text {
        color: #e40000;
        font-size: 12px;
        line-height: 16px;
      }
    }

    .payment-method-form {
      .payment-method-radio-container {
        .radio {
          margin-bottom: 12px;
        }
      }
    }

    .payment-method-tmb-container {
      .payment-method-tmb-form {
        display: flex;
        flex-flow: wrap;
        justify-content: center;
        margin-bottom: 32px;

        .warning-validate-information-section {
          background: rgba(242, 201, 76, 0.22);
          border: 1px solid #f2c94c;
          border-radius: 3px;
          color: #826200;
          display: flex;
          height: 46px;
          margin-top: 12px;
          margin-bottom: 24px;
          align-items: center;
          justify-content: center;

          .warning-icon {
            margin-right: 8px;
          }
        }

        .otp-information-text {
          margin-bottom: 24px;
          text-align: center;
        }
      }

      .otp-section {
        text-align: center;

        .otp-information-section {
          margin-bottom: 12px;

          .phone-number-information {
            font-family: 'psl_kanda_extraregular';
            margin-bottom: 12px;
          }
        }

        .otp-form {
          margin-bottom: 24px;

          .otp-input {
            margin: 0 auto;
            width: 75%;
          }
        }

        .otp-timeout-time {
          margin-bottom: 12px;
        }

        .resend-otp-section {
          margin-bottom: 12px;

          .resend-otp-btn {
            color: #009640;
            cursor: pointer;
            font-family: 'psl_kanda_extraregular';
          }
        }
      }
    }
  }

  .error-text-section {
    color: #e40000;
    font-size: 12px;
    line-height: 16px;
    margin-top: 8px;
    margin-left: 8px;
  }
}
</style>
